module.exports = __webpack_public_path__ + "img/bg.ffcb659e.jpg";